export default __webpack_public_path__ + "static/media/qr_app.5770cec7.jpeg";